module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Produtos em Estoque por Unidade")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.lista), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.textoUnidade(row.Unidade)))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(row.Produto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Quantidade))])])
  }), _vm._v(" "), (_vm.lista.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nenhum resultado para exibir")])]) : _vm._e()], 2), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Unidade")]), _vm._v(" "), _c('td', [_vm._v("Produto")]), _vm._v(" "), _c('td', [_vm._v("Quantidade")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f55c0fd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/dashboard/EstoqueNoMomento.vue
// module id = 304
// module chunks = 1